// ========================== src/components/Footer.tsx ==========================
// Removed: import React from 'react';

const Footer = () => (
  <footer className="footer p-4 bg-base-200 text-base-content text-center">
    <p>&copy; {new Date().getFullYear()} Swap-N-Stay. All rights reserved.</p>
  </footer>
);

export default Footer;
